import React from 'react';
import { Column, Row } from 'spw-shared/globalComponents';
import CirculationMultiplierTable from 'spw-components/programming-scenarios/building-hs-sc-scenario/circulation-multiplier-table';
import { GROWTH_CALCULATORS } from 'spw-constants';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { Box } from '@mui/material';
import {
  Row10TopPadding,
  USFBuildingTitle,
  RowBold,
  Row5TopPadding,
  USFLabel,
} from './styles';
import CalculationDefinitionsDialog from '../calculation-definitions-dialog';

const USFBuildingCalculationsRightPanel = ({
  calculatorType,
  isDownload,
}: {
  calculatorType: string;
  isDownload?: boolean;
}) => {
  const { getUnit } = useUnitConversion();
  const showUsfReminder =
    !isDownload &&
    calculatorType !== GROWTH_CALCULATORS.totalProgram &&
    calculatorType !==
      GROWTH_CALCULATORS.buildingHeadcountSeatcountDepartments &&
    calculatorType !== GROWTH_CALCULATORS.macroProgramming;

  return (
    <>
      <Row>
        <USFBuildingTitle
          style={{ flexDirection: 'row', alignItems: 'center' }}
        >
          CIRCULATION MULTIPLIER TABLE <CalculationDefinitionsDialog />
        </USFBuildingTitle>
      </Row>
      <CirculationMultiplierTable headerText="%" gridSize={5} />
      <Row10TopPadding>
        Look up the corresponding multiplier to your desired circulation % in
        the table above. Enter the multiplier in the Multiplier field to the
        left to calculate Circulation.
      </Row10TopPadding>
      <Row10TopPadding>
        <Column>
          <RowBold>Example</RowBold>
          <Row5TopPadding>
            40% Circulation = (40/(100-40)) = .67 Multiplier
          </Row5TopPadding>
        </Column>
      </Row10TopPadding>
      <Row10TopPadding>
        <Column>
          <RowBold>REMINDER</RowBold>
          {showUsfReminder && (
            <Box marginTop={0.5} marginBottom={0.5}>
              Use the <USFLabel>{getUnit('area')}</USFLabel>&nbsp;button to
              enter total {getUnit('area')} before programming the worksheet.
            </Box>
          )}
          <Box marginTop={0.5}>
            {getUnit('rentable-area')} is optional. Adding a Rentable Load
            Factor inserts rows which appear gray.
          </Box>
        </Column>
      </Row10TopPadding>
    </>
  );
};

export default USFBuildingCalculationsRightPanel;
